import type { AlpineComponent } from 'alpinejs'

export const $slider = Symbol('$slider')
export const hasSlider = <T extends object>(ctx: T): ctx is WithSlider<T> =>
  $slider in ctx

export type WithSlider<T = object> = T & { [$slider]: SliderCTX }

export interface SliderCTX extends AlpineComponent<object> {
  focusedIndex: number
  focusedSize: number
  initialized: boolean
  touched: boolean
  components: Map<'gallery' | 'thumbnails', HTMLElement>
  init(): void
  onLoad(target: HTMLElement): void
  handleIntersect(el: HTMLElement): void
  itemAtIndex(idx: number): Element | undefined
  indexOfItem(el: Element): number | undefined
  scrollTo(target: number | HTMLElement, offset?: number): Promise<void>
  readonly isLast: boolean
  readonly isFirst: boolean
  next(): void
  prev(): void
  itemCount: number
}
